import { render, staticRenderFns } from "./news-block.vue?vue&type=template&id=76af519a"
import script from "./news-block.vue?vue&type=script&lang=js"
export * from "./news-block.vue?vue&type=script&lang=js"
import style0 from "./news-block.vue?vue&type=style&index=0&id=76af519a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzButton: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/button/index.js').default,NewsCard: require('/opt/iaravia.ru/src/components/news-card.vue').default})
